const ENV_BANNER_CONFIG = {
  development: {
    label: "AMBIENTE LOCAL",
    className: "env-banner--development",
  },
  staging: {
    label: "AMBIENTE DE HOMOLOGAÇÃO",
    className: "env-banner--staging",
  },
};

function getEnvBannerConfig() {
  const env = process.env.REACT_APP_ENV || "development";
  return ENV_BANNER_CONFIG[env] || null;
}

export function isEnvironmentBannerVisible() {
  return Boolean(getEnvBannerConfig());
}

function EnvironmentBanner() {
  const config = getEnvBannerConfig();

  if (!config) {
    return null;
  }

  return (
    <div className={`env-banner ${config.className}`} role="status">
      {config.label}
    </div>
  );
}

export default EnvironmentBanner;
